var map = {
	"./": 67672,
	"./App": 73465,
	"./App.tsx": 73465,
	"./api": 31776,
	"./api/": 31776,
	"./api/app/appApi": 66200,
	"./api/app/appApi.ts": 66200,
	"./api/games/gamesApi": 57487,
	"./api/games/gamesApi.ts": 57487,
	"./api/games/gamesTypes": 27302,
	"./api/games/gamesTypes.ts": 27302,
	"./api/index": 31776,
	"./api/index.ts": 31776,
	"./api/transactions/transactionApi": 58954,
	"./api/transactions/transactionApi.ts": 58954,
	"./api/transactions/transactionTypes": 17728,
	"./api/transactions/transactionTypes.ts": 17728,
	"./api/user/userApi": 20022,
	"./api/user/userApi.ts": 20022,
	"./api/user/userTypes": 7129,
	"./api/user/userTypes.ts": 7129,
	"./assets/images/ad-games-background_img.webp": 48688,
	"./assets/images/ad_live-games-background_image.webp": 85692,
	"./assets/images/ad_main-amatic-icon.svg": 35631,
	"./assets/images/ad_main-games-icon.svg": 30926,
	"./assets/images/ad_main-icon_icon.svg": 59238,
	"./assets/images/ad_main-live-sport-icon.png": 77424,
	"./assets/images/ad_main-pragmatic-icon.png": 11079,
	"./assets/images/ad_main-sports-icon.png": 68505,
	"./assets/images/ad_matic-background_img.webp": 39254,
	"./assets/images/ad_sports-background_image.webp": 27156,
	"./assets/images/ad_tv-games-background_img.webp": 70272,
	"./assets/images/alert_close_icon.svg": 66225,
	"./assets/images/background-desktop_img.webp": 41221,
	"./assets/images/background_sign_in_img.png": 49694,
	"./assets/images/belt-background_img.png": 49467,
	"./assets/images/belt-hall-of-fame.png": 63889,
	"./assets/images/btn_up_arrow_icon.svg": 99646,
	"./assets/images/chip_error_icon.svg": 11645,
	"./assets/images/chip_success_icon.svg": 30311,
	"./assets/images/copy_icon.svg": 82796,
	"./assets/images/cross_top_icon.svg": 42885,
	"./assets/images/desktop_background-image.svg": 74534,
	"./assets/images/desktop_menu_down_arrow_icon.svg": 51540,
	"./assets/images/drawer_desktop_dicord_img.png": 5426,
	"./assets/images/drawer_desktop_dicord_img.svg": 81824,
	"./assets/images/drawer_desktop_facebook_img.png": 98918,
	"./assets/images/drawer_desktop_facebook_img.svg": 66328,
	"./assets/images/drawer_desktop_instagram_img.png": 37721,
	"./assets/images/drawer_desktop_instagram_img.svg": 51824,
	"./assets/images/drawer_desktop_youtube_img.png": 16847,
	"./assets/images/drawer_desktop_youtube_img.svg": 24038,
	"./assets/images/drawer_dicord_img.png": 68012,
	"./assets/images/drawer_facebook_img.png": 51248,
	"./assets/images/drawer_help_icon.svg": 38909,
	"./assets/images/drawer_instagram_img.png": 61396,
	"./assets/images/drawer_language_icon.svg": 99036,
	"./assets/images/drawer_privacy_icon.svg": 44369,
	"./assets/images/drawer_promotions_icon.svg": 5274,
	"./assets/images/drawer_rules_icon.svg": 15955,
	"./assets/images/drawer_support_icon.svg": 25294,
	"./assets/images/drawer_youtube_img.png": 95098,
	"./assets/images/flag_language_en_icon.svg": 44988,
	"./assets/images/flag_language_fr_icon.svg": 82125,
	"./assets/images/flag_language_he_icon.svg": 1435,
	"./assets/images/flag_language_tr_icon.svg": 51749,
	"./assets/images/footer_games_icon.svg": 51844,
	"./assets/images/footer_horses_icon.svg": 79560,
	"./assets/images/footer_live-sports_icon.svg": 99145,
	"./assets/images/footer_main_icon.svg": 53238,
	"./assets/images/footer_sports_icon.svg": 9010,
	"./assets/images/footer_tv-games_icon.svg": 68690,
	"./assets/images/game_arrow_icon.svg": 94156,
	"./assets/images/game_exit-full-screen_icon.svg": 63250,
	"./assets/images/game_exit-small-full-screen_icon.svg": 57206,
	"./assets/images/game_fullscreen_icon.svg": 4427,
	"./assets/images/game_play_button_img.svg": 13036,
	"./assets/images/game_small-full-screen_icon.svg": 22102,
	"./assets/images/games_arrow_icon.svg": 61403,
	"./assets/images/games_provider_arrow_icon.svg": 73127,
	"./assets/images/games_star_icon.svg": 86887,
	"./assets/images/hall_star_icon.svg": 72207,
	"./assets/images/header_gift_icon.svg": 29568,
	"./assets/images/header_menu_icon.svg": 37048,
	"./assets/images/header_signin_icon.svg": 69918,
	"./assets/images/input_cross_icon.svg": 22264,
	"./assets/images/input_eye_close.svg": 50776,
	"./assets/images/input_eye_open.svg": 37865,
	"./assets/images/input_search_icon.svg": 8140,
	"./assets/images/loader-ball-icon.png": 31997,
	"./assets/images/loader_logo_icon.svg": 92184,
	"./assets/images/main-logo-cbet_icon.png": 82414,
	"./assets/images/main-logo-koora_icon.png": 43713,
	"./assets/images/main-logo-live777_icon.svg": 97119,
	"./assets/images/modal_large-logo_icon.svg": 62255,
	"./assets/images/navbar_crashgames-icon.svg": 93035,
	"./assets/images/profile_back-arrow_icon.svg": 93267,
	"./assets/images/profile_cashback-history_icon.svg": 83061,
	"./assets/images/profile_cashback-icon.svg": 65246,
	"./assets/images/profile_cashback-update_icon.svg": 56951,
	"./assets/images/profile_casino-bet-history_icon.svg": 62128,
	"./assets/images/profile_change-password_icon.svg": 47812,
	"./assets/images/profile_filter_icon.svg": 23521,
	"./assets/images/profile_history-of-operation_icon.svg": 36534,
	"./assets/images/profile_logo_bet-history_icon.svg": 43066,
	"./assets/images/profile_logo_cashback-history_icon.svg": 65063,
	"./assets/images/profile_logo_change-password_icon.svg": 48312,
	"./assets/images/profile_logo_history-of-operation_icon.svg": 18904,
	"./assets/images/profile_logo_personal-data_icon.svg": 88861,
	"./assets/images/profile_person_icon.svg": 86452,
	"./assets/images/profile_personal-data_icon.svg": 19745,
	"./assets/images/profile_sign-out_icon.svg": 59259,
	"./assets/images/promotions_arrow_icon.svg": 74692,
	"./assets/images/promotions_first_img.png": 91217,
	"./assets/images/promotions_second_img.png": 91804,
	"./assets/images/promotions_third_img.png": 72766,
	"./assets/images/sign_in_login_input_icon.svg": 35379,
	"./assets/images/sign_in_password_input_icon.svg": 28648,
	"./assets/images/star.png": 76960,
	"./assets/lotties/button_loader": 51542,
	"./assets/lotties/button_loader.json": 51542,
	"./assets/lotties/error": 89284,
	"./assets/lotties/error.json": 89284,
	"./assets/lotties/work_loader": 89512,
	"./assets/lotties/work_loader.json": 89512,
	"./assets/navbar/background_cosmos.png": 84310,
	"./assets/navbar/background_girls.png": 71060,
	"./assets/navbar/background_slots.png": 35265,
	"./assets/navbar/background_sport-ball.png": 34247,
	"./assets/navbar/background_sport.png": 54009,
	"./assets/navbar/icon_amatic.png": 25732,
	"./assets/navbar/icon_evolution.png": 40228,
	"./assets/navbar/icon_games.png": 41779,
	"./assets/navbar/icon_live-games.png": 7470,
	"./assets/navbar/icon_live-sport.png": 34634,
	"./assets/navbar/icon_pragmatic.png": 24040,
	"./assets/navbar/icon_sport.png": 25971,
	"./assets/navbar/icon_vivogaming.png": 55492,
	"./assets/providersImages/provider_1x2Gaming_logo.png": 43832,
	"./assets/providersImages/provider_Amatic_logo.png": 63736,
	"./assets/providersImages/provider_Apollo_logo.png": 37368,
	"./assets/providersImages/provider_Aristocrat_logo.png": 49359,
	"./assets/providersImages/provider_BB-games_logo.png": 44957,
	"./assets/providersImages/provider_Bet-games_logo.png": 1946,
	"./assets/providersImages/provider_Blueprint-Gaming_logo.png": 99190,
	"./assets/providersImages/provider_Booongo_logo.png": 88950,
	"./assets/providersImages/provider_Cq9_logo.png": 30984,
	"./assets/providersImages/provider_Dragon-soft_logo.png": 94409,
	"./assets/providersImages/provider_Ebet_color_logo.png": 53885,
	"./assets/providersImages/provider_Evolution_logo.png": 95706,
	"./assets/providersImages/provider_Evoplay_logo.png": 68707,
	"./assets/providersImages/provider_Ezugi_logo.png": 67872,
	"./assets/providersImages/provider_Fantasma-Games_logo.png": 79307,
	"./assets/providersImages/provider_Fugaso_logo.png": 25679,
	"./assets/providersImages/provider_Gamefish-Global_logo.png": 63251,
	"./assets/providersImages/provider_Gaminator_logo.png": 13634,
	"./assets/providersImages/provider_Gamzix_logo.png": 50208,
	"./assets/providersImages/provider_Greentube_logo.png": 55875,
	"./assets/providersImages/provider_Habanero_logo.png": 36396,
	"./assets/providersImages/provider_Hacksaw_logo.png": 23444,
	"./assets/providersImages/provider_IGT_logo.png": 4245,
	"./assets/providersImages/provider_Igrosoft_logo.png": 65318,
	"./assets/providersImages/provider_Iron-Dog_logo.png": 20662,
	"./assets/providersImages/provider_Kajot_logo.png": 78307,
	"./assets/providersImages/provider_Kalamba-Games_logo.png": 58749,
	"./assets/providersImages/provider_Kiron_logo.png": 68703,
	"./assets/providersImages/provider_Konami_logo.png": 96736,
	"./assets/providersImages/provider_Lady-Luck_logo.png": 20225,
	"./assets/providersImages/provider_Maverick_logo.png": 59821,
	"./assets/providersImages/provider_Merkur_logo.png": 73993,
	"./assets/providersImages/provider_Microgaming_logo.png": 39629,
	"./assets/providersImages/provider_Mobilots_logo.png": 27071,
	"./assets/providersImages/provider_Netent_logo.png": 79183,
	"./assets/providersImages/provider_Netgame_logo.png": 46881,
	"./assets/providersImages/provider_Nolimit-City_logo.png": 87050,
	"./assets/providersImages/provider_OMI-Gaming_logo.png": 27644,
	"./assets/providersImages/provider_OneTouch_logo.png": 13962,
	"./assets/providersImages/provider_Playngo_logo.png": 95119,
	"./assets/providersImages/provider_Playpearls_logo.png": 16594,
	"./assets/providersImages/provider_Playson_logo.png": 59008,
	"./assets/providersImages/provider_Pragmatic-Play_logo.png": 30365,
	"./assets/providersImages/provider_Pragmatic-play-live_logo.png": 72688,
	"./assets/providersImages/provider_Print-Studios_logo.png": 58870,
	"./assets/providersImages/provider_Push-Gaming_logo.png": 47489,
	"./assets/providersImages/provider_Quickspin_logo.png": 43427,
	"./assets/providersImages/provider_Red-Tiger_logo.png": 98755,
	"./assets/providersImages/provider_Relax-Gaming_logo.png": 96744,
	"./assets/providersImages/provider_Revolver-Gaming_logo.png": 33902,
	"./assets/providersImages/provider_Rtg-Slots_logo.png": 55992,
	"./assets/providersImages/provider_Skywind-Group_logo.png": 38585,
	"./assets/providersImages/provider_Skywind-life_logo.png": 56031,
	"./assets/providersImages/provider_Slotmill_logo.png": 46517,
	"./assets/providersImages/provider_Spearhead_logo.png": 13250,
	"./assets/providersImages/provider_Splitrock_logo.png": 62896,
	"./assets/providersImages/provider_Thunderkick_logo.png": 59195,
	"./assets/providersImages/provider_Tpg_logo.png": 81629,
	"./assets/providersImages/provider_Wazdan_logo.png": 44267,
	"./assets/providersImages/provider_Yggdrasil_logo.png": 30245,
	"./assets/providersImages/provider_august_gaming_logo.png": 40317,
	"./assets/providersImages/provider_austria_color_logo.png": 98337,
	"./assets/providersImages/provider_betradar_virtual_sports_logo.png": 22314,
	"./assets/providersImages/provider_betskilla_color_logo.png": 32579,
	"./assets/providersImages/provider_cqgaming_color_logo.png": 99639,
	"./assets/providersImages/provider_fishing_color_logo.png": 67312,
	"./assets/providersImages/provider_gameart_logo.png": 2899,
	"./assets/providersImages/provider_playtech_logo.png": 10335,
	"./components/alerts/Work": 71181,
	"./components/alerts/Work.tsx": 71181,
	"./components/blocks/GameBlock": 36323,
	"./components/blocks/GameBlock.tsx": 36323,
	"./components/cards/desktopCards/PromotionsCards": 6545,
	"./components/cards/desktopCards/PromotionsCards.tsx": 6545,
	"./components/cards/discoverCards": 16310,
	"./components/cards/discoverCards/": 16310,
	"./components/cards/discoverCards/index": 16310,
	"./components/cards/discoverCards/index.tsx": 16310,
	"./components/cards/providerCards": 91146,
	"./components/cards/providerCards/": 91146,
	"./components/cards/providerCards/index": 91146,
	"./components/cards/providerCards/index.tsx": 91146,
	"./components/forms/Login": 83276,
	"./components/forms/Login.tsx": 83276,
	"./components/gameSwitcher": 19834,
	"./components/gameSwitcher/": 19834,
	"./components/gameSwitcher/index": 19834,
	"./components/gameSwitcher/index.tsx": 19834,
	"./components/games": 5140,
	"./components/games/": 5140,
	"./components/games/DesktopGame": 58839,
	"./components/games/DesktopGame.tsx": 58839,
	"./components/games/ProviderBlock": 32741,
	"./components/games/ProviderBlock.tsx": 32741,
	"./components/games/index": 5140,
	"./components/games/index.tsx": 5140,
	"./components/language": 39969,
	"./components/language/": 39969,
	"./components/language/index": 39969,
	"./components/language/index.tsx": 39969,
	"./components/modal": 98807,
	"./components/modal/": 98807,
	"./components/modal/ErrorModal": 8994,
	"./components/modal/ErrorModal.tsx": 8994,
	"./components/modal/HelpModal": 62575,
	"./components/modal/HelpModal.tsx": 62575,
	"./components/modal/PromotionModal": 41393,
	"./components/modal/PromotionModal.tsx": 41393,
	"./components/modal/RulesModal": 47511,
	"./components/modal/RulesModal.tsx": 47511,
	"./components/modal/index": 98807,
	"./components/modal/index.tsx": 98807,
	"./components/scrollButton": 2944,
	"./components/scrollButton/": 2944,
	"./components/scrollButton/index": 2944,
	"./components/scrollButton/index.tsx": 2944,
	"./components/seo": 4170,
	"./components/seo/": 4170,
	"./components/seo/index": 4170,
	"./components/seo/index.tsx": 4170,
	"./components/slider": 5002,
	"./components/slider/": 5002,
	"./components/slider/index": 5002,
	"./components/slider/index.tsx": 5002,
	"./components/wrapper/drawer": 91245,
	"./components/wrapper/drawer/": 91245,
	"./components/wrapper/drawer/DrawerContent": 97771,
	"./components/wrapper/drawer/DrawerContent.tsx": 97771,
	"./components/wrapper/drawer/DrawerFooter": 44851,
	"./components/wrapper/drawer/DrawerFooter.tsx": 44851,
	"./components/wrapper/drawer/NavigationLeftBar": 62380,
	"./components/wrapper/drawer/NavigationLeftBar.tsx": 62380,
	"./components/wrapper/drawer/index": 91245,
	"./components/wrapper/drawer/index.tsx": 91245,
	"./components/wrapper/footer": 78590,
	"./components/wrapper/footer/": 78590,
	"./components/wrapper/footer/FooterDesktop": 86392,
	"./components/wrapper/footer/FooterDesktop.tsx": 86392,
	"./components/wrapper/footer/index": 78590,
	"./components/wrapper/footer/index.tsx": 78590,
	"./components/wrapper/header": 39324,
	"./components/wrapper/header/": 39324,
	"./components/wrapper/header/CashbackButton": 38629,
	"./components/wrapper/header/CashbackButton.tsx": 38629,
	"./components/wrapper/header/HeaderDesktop": 25438,
	"./components/wrapper/header/HeaderDesktop.tsx": 25438,
	"./components/wrapper/header/InfoContainer": 32770,
	"./components/wrapper/header/InfoContainer.tsx": 32770,
	"./components/wrapper/header/NavBar": 76485,
	"./components/wrapper/header/NavBar.tsx": 76485,
	"./components/wrapper/header/SecondHeaderDesktop": 55321,
	"./components/wrapper/header/SecondHeaderDesktop.tsx": 55321,
	"./components/wrapper/header/index": 39324,
	"./components/wrapper/header/index.tsx": 39324,
	"./constants/breakpoints": 89294,
	"./constants/breakpoints.ts": 89294,
	"./constants/config": 43107,
	"./constants/config.ts": 43107,
	"./constants/routing": 52393,
	"./constants/routing.tsx": 52393,
	"./constants/theme-constants": 65365,
	"./constants/theme-constants.ts": 65365,
	"./constants/types": 99314,
	"./constants/types.ts": 99314,
	"./custom.d": 33023,
	"./custom.d.ts": 33023,
	"./features/cards-menu": 6524,
	"./features/cards-menu/": 6524,
	"./features/cards-menu/assets/amatic_background.png": 99108,
	"./features/cards-menu/assets/amatic_icon.png": 71862,
	"./features/cards-menu/assets/background_cosmos.png": 8016,
	"./features/cards-menu/assets/games_background.webp": 39453,
	"./features/cards-menu/assets/games_icon.svg": 21217,
	"./features/cards-menu/assets/lines_background.png": 99429,
	"./features/cards-menu/assets/live_background.png": 318,
	"./features/cards-menu/assets/live_icon.svg": 34991,
	"./features/cards-menu/assets/pragmatic_background.webp": 41716,
	"./features/cards-menu/assets/pragmatic_icon.png": 48731,
	"./features/cards-menu/assets/sport_background.png": 90601,
	"./features/cards-menu/assets/sport_icon.svg": 14795,
	"./features/cards-menu/assets/tv-games_background.webp": 24302,
	"./features/cards-menu/assets/tv-games_icon.svg": 34759,
	"./features/cards-menu/config/cards-menu.config": 27478,
	"./features/cards-menu/config/cards-menu.config.ts": 27478,
	"./features/cards-menu/index": 6524,
	"./features/cards-menu/index.ts": 6524,
	"./features/cards-menu/types/card.types": 65037,
	"./features/cards-menu/types/card.types.ts": 65037,
	"./features/cards-menu/ui/cards-menu": 79084,
	"./features/cards-menu/ui/cards-menu.tsx": 79084,
	"./features/hall-of-fame": 41687,
	"./features/hall-of-fame/": 41687,
	"./features/hall-of-fame/api/hall-of-fame.api": 69681,
	"./features/hall-of-fame/api/hall-of-fame.api.ts": 69681,
	"./features/hall-of-fame/assets/background_star.png": 38904,
	"./features/hall-of-fame/assets/belt.png": 42213,
	"./features/hall-of-fame/assets/hall-of-fame_background.png": 54494,
	"./features/hall-of-fame/index": 41687,
	"./features/hall-of-fame/index.ts": 41687,
	"./features/hall-of-fame/model/hall-of-fame.effects": 46453,
	"./features/hall-of-fame/model/hall-of-fame.effects.ts": 46453,
	"./features/hall-of-fame/model/hall-of-fame.store": 82643,
	"./features/hall-of-fame/model/hall-of-fame.store.ts": 82643,
	"./features/hall-of-fame/model/hall-of-fame.types": 68858,
	"./features/hall-of-fame/model/hall-of-fame.types.ts": 68858,
	"./features/hall-of-fame/ui/calendar": 53079,
	"./features/hall-of-fame/ui/calendar.tsx": 53079,
	"./features/hall-of-fame/ui/fame-item": 99871,
	"./features/hall-of-fame/ui/fame-item.tsx": 99871,
	"./features/hall-of-fame/ui/hall-of-fame": 34583,
	"./features/hall-of-fame/ui/hall-of-fame.tsx": 34583,
	"./features/hall-of-fame/ui/list": 56968,
	"./features/hall-of-fame/ui/list.tsx": 56968,
	"./features/hall-of-fame/ui/top-hall-of-fame": 66099,
	"./features/hall-of-fame/ui/top-hall-of-fame.tsx": 66099,
	"./features/high-roller/api/high-roller.api": 18980,
	"./features/high-roller/api/high-roller.api.ts": 18980,
	"./features/high-roller/assets/down_arrow.svg": 8673,
	"./features/high-roller/model/high-roller.effects": 41763,
	"./features/high-roller/model/high-roller.effects.ts": 41763,
	"./features/high-roller/model/high-roller.store": 29183,
	"./features/high-roller/model/high-roller.store.ts": 29183,
	"./features/high-roller/model/high-roller.types": 39172,
	"./features/high-roller/model/high-roller.types.ts": 39172,
	"./features/high-roller/ui/high-roller": 17119,
	"./features/high-roller/ui/high-roller-item": 62640,
	"./features/high-roller/ui/high-roller-item.tsx": 62640,
	"./features/high-roller/ui/high-roller.tsx": 17119,
	"./features/high-roller/ui/star": 24049,
	"./features/high-roller/ui/star.tsx": 24049,
	"./features/high-roller/ui/ticker": 85326,
	"./features/high-roller/ui/ticker.tsx": 85326,
	"./features/high-roller/ui/top-list": 83898,
	"./features/high-roller/ui/top-list.tsx": 83898,
	"./helpers/effector": 95514,
	"./helpers/effector.ts": 95514,
	"./helpers/formatDate": 88400,
	"./helpers/formatDate.ts": 88400,
	"./helpers/gamesHelper/openGame": 726,
	"./helpers/gamesHelper/openGame.ts": 726,
	"./helpers/getCorrectRoutes": 16884,
	"./helpers/getCorrectRoutes.tsx": 16884,
	"./helpers/providerHelper": 35336,
	"./helpers/providerHelper/": 35336,
	"./helpers/providerHelper/index": 35336,
	"./helpers/providerHelper/index.tsx": 35336,
	"./helpers/providerHelper/providersImages": 29438,
	"./helpers/providerHelper/providersImages.ts": 29438,
	"./helpers/unionArraysByKey": 44296,
	"./helpers/unionArraysByKey.ts": 44296,
	"./hooks/useActions": 6121,
	"./hooks/useActions.ts": 6121,
	"./hooks/useComponentSize": 6426,
	"./hooks/useComponentSize.ts": 6426,
	"./hooks/useDebounce": 73598,
	"./hooks/useDebounce.ts": 73598,
	"./hooks/useDocumentTitle": 52483,
	"./hooks/useDocumentTitle.ts": 52483,
	"./hooks/useEventListener": 15560,
	"./hooks/useEventListener.ts": 15560,
	"./hooks/useFullScreen": 23270,
	"./hooks/useFullScreen.ts": 23270,
	"./hooks/useInput": 56803,
	"./hooks/useInput.ts": 56803,
	"./hooks/useInterval": 88129,
	"./hooks/useInterval.ts": 88129,
	"./hooks/useKeyPress": 46211,
	"./hooks/useKeyPress.ts": 46211,
	"./hooks/useMediaQuery": 24635,
	"./hooks/useMediaQuery.ts": 24635,
	"./hooks/useOutsideClick": 50061,
	"./hooks/useOutsideClick.ts": 50061,
	"./hooks/usePortal": 83683,
	"./hooks/usePortal.ts": 83683,
	"./hooks/useScript": 33745,
	"./hooks/useScript.ts": 33745,
	"./hooks/useStorage": 46091,
	"./hooks/useStorage.ts": 46091,
	"./hooks/useTime": 96915,
	"./hooks/useTime.ts": 96915,
	"./hooks/useTimeCount": 82978,
	"./hooks/useTimeCount.ts": 82978,
	"./hooks/useTypedSelector": 11573,
	"./hooks/useTypedSelector.ts": 11573,
	"./hooks/useUnload": 76120,
	"./hooks/useUnload.ts": 76120,
	"./i18n": 5861,
	"./i18n.ts": 5861,
	"./index": 67672,
	"./index.css": 51174,
	"./index.tsx": 67672,
	"./locales/en/translation": 61996,
	"./locales/en/translation.json": 61996,
	"./locales/fr/translation": 65387,
	"./locales/fr/translation.json": 65387,
	"./locales/he/translation": 61729,
	"./locales/he/translation.json": 61729,
	"./locales/tr/translation": 10096,
	"./locales/tr/translation.json": 10096,
	"./pages/Game": 23132,
	"./pages/Game.tsx": 23132,
	"./pages/Games": 19969,
	"./pages/Games.desktop": 82092,
	"./pages/Games.desktop.tsx": 82092,
	"./pages/Games.tsx": 19969,
	"./pages/HallOfFame": 81520,
	"./pages/HallOfFame.desktop": 36686,
	"./pages/HallOfFame.desktop.tsx": 36686,
	"./pages/HallOfFame.tsx": 81520,
	"./pages/Horses": 49305,
	"./pages/Horses.tsx": 49305,
	"./pages/Main": 16158,
	"./pages/Main.desktop": 99864,
	"./pages/Main.desktop.tsx": 99864,
	"./pages/Main.tsx": 16158,
	"./pages/Promotions": 12775,
	"./pages/Promotions.tsx": 12775,
	"./pages/Provider": 28144,
	"./pages/Provider.tsx": 28144,
	"./pages/SingIn": 65774,
	"./pages/SingIn.tsx": 65774,
	"./pages/Sport": 93896,
	"./pages/Sport.tsx": 93896,
	"./pages/StaticPage": 32982,
	"./pages/StaticPage.tsx": 32982,
	"./pages/TvGames": 31128,
	"./pages/TvGames.desktop": 27836,
	"./pages/TvGames.desktop.tsx": 27836,
	"./pages/TvGames.tsx": 31128,
	"./pages/profile": 62695,
	"./pages/profile/": 62695,
	"./pages/profile/BetHistory": 28969,
	"./pages/profile/BetHistory.desktop": 15776,
	"./pages/profile/BetHistory.desktop.tsx": 15776,
	"./pages/profile/BetHistory.tsx": 28969,
	"./pages/profile/Cashback": 23396,
	"./pages/profile/Cashback.desktop": 63248,
	"./pages/profile/Cashback.desktop.tsx": 63248,
	"./pages/profile/Cashback.tsx": 23396,
	"./pages/profile/CashbackHistory": 18284,
	"./pages/profile/CashbackHistory.desktop": 45049,
	"./pages/profile/CashbackHistory.desktop.tsx": 45049,
	"./pages/profile/CashbackHistory.tsx": 18284,
	"./pages/profile/OperationHistory": 30347,
	"./pages/profile/OperationHistory.desktop": 86082,
	"./pages/profile/OperationHistory.desktop.tsx": 86082,
	"./pages/profile/OperationHistory.tsx": 30347,
	"./pages/profile/PersonalData": 51566,
	"./pages/profile/PersonalData.desktop": 66881,
	"./pages/profile/PersonalData.desktop.tsx": 66881,
	"./pages/profile/PersonalData.tsx": 51566,
	"./pages/profile/Settings": 68644,
	"./pages/profile/Settings.desktop": 5979,
	"./pages/profile/Settings.desktop.tsx": 5979,
	"./pages/profile/Settings.tsx": 68644,
	"./pages/profile/index": 62695,
	"./pages/profile/index.tsx": 62695,
	"./react-app-env.d": 44398,
	"./react-app-env.d.ts": 44398,
	"./reportWebVitals": 58983,
	"./reportWebVitals.ts": 58983,
	"./routes": 11381,
	"./routes/": 11381,
	"./routes/desktop-app": 83290,
	"./routes/desktop-app.tsx": 83290,
	"./routes/index": 11381,
	"./routes/index.tsx": 11381,
	"./routes/mobile-app": 30835,
	"./routes/mobile-app.tsx": 30835,
	"./service-worker": 31943,
	"./service-worker.ts": 31943,
	"./serviceWorkerRegistration": 82305,
	"./serviceWorkerRegistration.ts": 82305,
	"./services/PortalService": 34584,
	"./services/PortalService.tsx": 34584,
	"./services/SocketService": 51931,
	"./services/SocketService.tsx": 51931,
	"./services/betbbyService": 28625,
	"./services/betbbyService.ts": 28625,
	"./services/tawkService": 30655,
	"./services/tawkService.ts": 30655,
	"./settings": 11080,
	"./settings/": 11080,
	"./settings/index": 11080,
	"./settings/index.ts": 11080,
	"./settings/koora_settings": 8479,
	"./settings/koora_settings.json": 8479,
	"./settings/live777_settings": 31871,
	"./settings/live777_settings.json": 31871,
	"./settings/local_settings": 90183,
	"./settings/local_settings.json": 90183,
	"./store": 4456,
	"./store/": 4456,
	"./store/actions": 32380,
	"./store/actions/": 32380,
	"./store/actions/appActions": 18901,
	"./store/actions/appActions.ts": 18901,
	"./store/actions/gameActions": 13590,
	"./store/actions/gameActions.ts": 13590,
	"./store/actions/index": 32380,
	"./store/actions/index.ts": 32380,
	"./store/actions/transcationActions": 77857,
	"./store/actions/transcationActions.ts": 77857,
	"./store/actions/userActions": 51757,
	"./store/actions/userActions.ts": 51757,
	"./store/index": 4456,
	"./store/index.ts": 4456,
	"./store/reducers": 77931,
	"./store/reducers/": 77931,
	"./store/reducers/appReducer": 40700,
	"./store/reducers/appReducer.ts": 40700,
	"./store/reducers/gameReducer": 87961,
	"./store/reducers/gameReducer.ts": 87961,
	"./store/reducers/index": 77931,
	"./store/reducers/index.ts": 77931,
	"./store/reducers/transactionReducer": 56474,
	"./store/reducers/transactionReducer.ts": 56474,
	"./store/reducers/userReducer": 65637,
	"./store/reducers/userReducer.ts": 65637,
	"./store/types/appTypes": 31559,
	"./store/types/appTypes.ts": 31559,
	"./store/types/gamesTypes": 51415,
	"./store/types/gamesTypes.ts": 51415,
	"./store/types/transactionTypes": 97456,
	"./store/types/transactionTypes.ts": 97456,
	"./store/types/userTypes": 95333,
	"./store/types/userTypes.ts": 95333,
	"./ui/AccordionSelect": 21276,
	"./ui/AccordionSelect.tsx": 21276,
	"./ui/ArrowButton": 33124,
	"./ui/ArrowButton.tsx": 33124,
	"./ui/BackButton": 19906,
	"./ui/BackButton.tsx": 19906,
	"./ui/CustomChip": 45015,
	"./ui/CustomChip.tsx": 45015,
	"./ui/CustomSearch": 49059,
	"./ui/CustomSearch.tsx": 49059,
	"./ui/DesktopGame": 75179,
	"./ui/DesktopGame.tsx": 75179,
	"./ui/DesktopProfileMenu": 74497,
	"./ui/DesktopProfileMenu.tsx": 74497,
	"./ui/DiscoverCard": 53474,
	"./ui/DiscoverCard.tsx": 53474,
	"./ui/FilterDateCustom": 42049,
	"./ui/FilterDateCustom.tsx": 42049,
	"./ui/GameCard": 90363,
	"./ui/GameCard.tsx": 90363,
	"./ui/GameProviderCard": 92065,
	"./ui/GameProviderCard.tsx": 92065,
	"./ui/GoldTime": 70554,
	"./ui/GoldTime.tsx": 70554,
	"./ui/GoldenButton": 55092,
	"./ui/GoldenButton.tsx": 55092,
	"./ui/HistoryItem": 66826,
	"./ui/HistoryItem.tsx": 66826,
	"./ui/Jackpot": 64056,
	"./ui/Jackpot.tsx": 64056,
	"./ui/LazyImage": 44060,
	"./ui/LazyImage.tsx": 44060,
	"./ui/ListMenu": 34847,
	"./ui/ListMenu.tsx": 34847,
	"./ui/Odometer": 148,
	"./ui/Odometer.tsx": 148,
	"./ui/OperationItem": 99885,
	"./ui/OperationItem.tsx": 99885,
	"./ui/PromotionCard": 47324,
	"./ui/PromotionCard.tsx": 47324,
	"./ui/SelectButton": 22964,
	"./ui/SelectButton.tsx": 22964,
	"./ui/SocialLinks": 50141,
	"./ui/SocialLinks.tsx": 50141,
	"./ui/StyledButton": 30413,
	"./ui/StyledButton.tsx": 30413,
	"./ui/StyledMobileButton": 75123,
	"./ui/StyledMobileButton.tsx": 75123,
	"./ui/adCard/DesktopCard": 45570,
	"./ui/adCard/DesktopCard.tsx": 45570,
	"./ui/adCard/FluidCard": 13538,
	"./ui/adCard/FluidCard.tsx": 13538,
	"./ui/adCard/menu-card": 40794,
	"./ui/adCard/menu-card.tsx": 40794,
	"./ui/containers": 59980,
	"./ui/containers.ts": 59980,
	"./ui/loaders/DotsLottieLoader": 95848,
	"./ui/loaders/DotsLottieLoader.tsx": 95848,
	"./ui/loaders/Loader": 75061,
	"./ui/loaders/Loader.tsx": 75061,
	"./ui/loaders/LottieWorkLoader": 156,
	"./ui/loaders/LottieWorkLoader.tsx": 156,
	"./ui/loaders/PrettyLoader": 27707,
	"./ui/loaders/PrettyLoader.tsx": 27707,
	"./ui/material-kit/Accordion": 2019,
	"./ui/material-kit/Accordion.tsx": 2019,
	"./ui/material-kit/Alert": 32150,
	"./ui/material-kit/Alert.tsx": 32150,
	"./ui/material-kit/CustomDatePicker": 63419,
	"./ui/material-kit/CustomDatePicker.tsx": 63419,
	"./ui/material-kit/Drawer": 25671,
	"./ui/material-kit/Drawer.tsx": 25671,
	"./ui/material-kit/Modal": 37498,
	"./ui/material-kit/Modal.tsx": 37498,
	"./ui/material-kit/SmartSearchSelect": 68134,
	"./ui/material-kit/SmartSearchSelect.tsx": 68134,
	"./ui/material-kit/TextField": 28728,
	"./ui/material-kit/TextField.tsx": 28728,
	"./ui/material-kit/Toolbar": 58824,
	"./ui/material-kit/Toolbar.tsx": 58824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;